const useReadableId = () => {
    const getReadableId = (numberId: number) => "ID-"+numberId;
    return {
        getReadableId
    }
}
export default useReadableId;